import axios from "axios";

const configuredBackendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const isLocalApp = ["127.0.0.1", "localhost"].includes(window.location.hostname);
const BACKEND_URL = isLocalApp ? "" : configuredBackendUrl;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 8000,
});

// Attach Bearer token from localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "No se pudo conectar con el servidor. Intenta de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
